import * as React from "react";

interface IProps {
    name: string;
    value: string | number;
}

export const ProductCollectionTileViewGroupState: React.FC<IProps> = ({ name, value }) => {
    return (
        <div className="groupStat">
            <div className="groupStatTitle">{`${name}:`}</div>
            <div>{value}</div>
        </div>
    );
};
